/**
 * ODDFISH — Masterton case study page
 * Matches live oddfishmedia.com.au/case-studies/marsterton/
 */
(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");
  var countersStarted = false;

  function prefersReducedMotion() {
    return REDUCED.matches;
  }

  function initAos() {
    if (typeof AOS === "undefined") return;

    if (!window.__oddfishMastertonAosInit) {
      AOS.init({
        once: true,
        duration: 800,
        easing: "ease-out-cubic",
        offset: 120,
        disable: prefersReducedMotion()
      });
      window.__oddfishMastertonAosInit = true;
    } else {
      AOS.refresh();
    }
  }

  function revealStrike(strike) {
    if (!strike || strike.dataset.mastertonStrikeDone === "true") return;

    if (prefersReducedMotion()) {
      strike.dataset.mastertonStrikeDone = "true";
      strike.classList.add("strike-visible");
      return;
    }

    strike.classList.remove("strike-visible");
    void strike.offsetWidth;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        strike.dataset.mastertonStrikeDone = "true";
        strike.classList.add("strike-visible");
      });
    });
  }

  function bindStrikeReveal(strike) {
    if (!("IntersectionObserver" in window)) {
      revealStrike(strike);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          window.setTimeout(function () {
            revealStrike(strike);
          }, 200);
          observer.unobserve(strike);
        });
      },
      { threshold: 0.3, rootMargin: "0px 0px -10% 0px" }
    );

    observer.observe(strike);
  }

  function playAosElement(el) {
    if (!el || !el.hasAttribute("data-aos")) return;
    if (el.classList.contains("aos-animate")) return;
    el.classList.add("aos-init");
    el.classList.add("aos-animate");
  }

  function playSectionAos(section) {
    section.querySelectorAll("[data-aos]").forEach(function (el) {
      playAosElement(el);
    });

    section.querySelectorAll(".media_wrapper .left_side").forEach(playAosElement);
    section.querySelectorAll(".media_inner_quote .quote").forEach(playAosElement);
  }

  function animateCounters(page) {
    if (countersStarted) return;

    var counters = page.querySelectorAll(".case_counter");
    if (!counters.length) return;

    countersStarted = true;

    if (prefersReducedMotion()) {
      counters.forEach(function (counter) {
        var countTo = parseInt(counter.getAttribute("data-count"), 10);
        if (!isNaN(countTo)) counter.textContent = String(countTo);
      });
      return;
    }

    counters.forEach(function (counter) {
      var countTo = parseInt(counter.getAttribute("data-count"), 10);
      if (isNaN(countTo)) return;

      var start = performance.now();
      var duration = 1300;

      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        counter.textContent = String(Math.floor(progress * countTo));
        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          counter.textContent = String(countTo);
        }
      }

      window.requestAnimationFrame(tick);
    });
  }

  function triggerAnimateSection(section, page) {
    if (section.dataset.mastertonScrolled === "true") return;
    section.dataset.mastertonScrolled = "true";
    section.classList.add("scrolled");
    playSectionAos(section);
    animateCounters(page);
  }

  function initStrikes(page) {
    page.querySelectorAll(".case_flexable h2.strike").forEach(function (strike) {
      if (strike.closest(".no_strike")) return;
      if (strike.dataset.mastertonStrikeBound === "true") return;
      strike.dataset.mastertonStrikeBound = "true";
      bindStrikeReveal(strike);
    });
  }

  function initLottie(page) {
    var player = page.querySelector("lottie-player");
    if (!player || player.dataset.lottieInit === "true") return;

    function setup() {
      if (player.dataset.lottieInit === "true") return;
      player.dataset.lottieInit = "true";

      if (prefersReducedMotion()) {
        if (typeof player.seek === "function") player.seek("100%");
        return;
      }

      if (typeof player.play === "function") {
        player.play();
      }

      if (typeof LottieInteractivity !== "undefined") {
        try {
          LottieInteractivity.create({
            player: player,
            mode: "cursor",
            actions: [{ type: "hover", forceFlag: false }]
          });
        } catch (error) {
          /* optional enhancement */
        }
      }
    }

    player.addEventListener("ready", setup);
    player.addEventListener("load", setup);

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements.whenDefined("lottie-player").then(function () {
        window.setTimeout(setup, 100);
      });
    }

    window.setTimeout(setup, 1500);
  }

  function handleScroll(page) {
    var bottomOfWindow = window.scrollY + window.innerHeight;

    page.querySelectorAll(".animate").forEach(function (section) {
      var bottomOfSection = section.offsetTop + section.offsetHeight - 50;

      if (bottomOfWindow > bottomOfSection) {
        triggerAnimateSection(section, page);
      }
    });
  }

  function initCaseStrikeHover(page) {
    page.querySelectorAll(".case_strike.striker").forEach(function (btn) {
      if (btn.dataset.mastertonStrikerBound === "true") return;
      btn.dataset.mastertonStrikerBound = "true";

      btn.addEventListener("mouseenter", function () {
        btn.classList.add("striker-visible");
      });
      btn.addEventListener("mouseleave", function () {
        btn.classList.remove("striker-visible");
      });
      btn.addEventListener("focus", function () {
        btn.classList.add("striker-visible");
      });
      btn.addEventListener("blur", function () {
        btn.classList.remove("striker-visible");
      });
    });
  }

  function initBannerStrike(page) {
    page.querySelectorAll(".single_case_banner .strike").forEach(revealStrike);
  }

  function initMastertonPage(root) {
    var page =
      (root && root.querySelector ? root.querySelector(".oddfish-case-study-masterton-page") : null) ||
      document.querySelector(".oddfish-case-study-masterton-page");
    if (!page || page.dataset.oddfishMastertonInit === "true") return;

    page.dataset.oddfishMastertonInit = "true";
    initAos();
    initBannerStrike(page);
    initStrikes(page);
    initCaseStrikeHover(page);
    initLottie(page);

    var ticking = false;
    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll(page);
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener(
      "resize",
      function () {
        handleScroll(page);
      },
      { passive: true }
    );

    handleScroll(page);

    setTimeout(function () {
      initAos();
      handleScroll(page);
    }, 400);

    setTimeout(function () {
      initAos();
      handleScroll(page);
    }, 1200);
  }

  function boot() {
    initMastertonPage(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.addEventListener("load", function () {
    initAos();
    var page = document.querySelector(".oddfish-case-study-masterton-page");
    if (page) handleScroll(page);
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target && event.target.querySelector(".oddfish-case-study-masterton-page")) {
      countersStarted = false;
      var page = event.target.querySelector(".oddfish-case-study-masterton-page");
      if (page) {
        delete page.dataset.oddfishMastertonInit;
        page.querySelectorAll("[data-masterton-strike-bound]").forEach(function (el) {
          delete el.dataset.mastertonStrikeBound;
          delete el.dataset.mastertonStrikeDone;
        });
        page.querySelectorAll(".animate").forEach(function (el) {
          delete el.dataset.mastertonScrolled;
        });
        page.querySelectorAll("lottie-player").forEach(function (el) {
          delete el.dataset.lottieInit;
        });
      }
      initMastertonPage(event.target);
    }
  });

  REDUCED.addEventListener("change", function () {
    countersStarted = false;
    var page = document.querySelector(".oddfish-case-study-masterton-page");
    if (!page) return;
    delete page.dataset.oddfishMastertonInit;
    page.querySelectorAll(".animate").forEach(function (el) {
      delete el.dataset.mastertonScrolled;
    });
    boot();
  });
})();
